import React from 'react';
import { useIntl } from 'react-intl';
import { SerializedSmartLinkVersionTheme } from 'fym-shared/src/smartlinks/types';
import { TypedMemo } from '../../common/types';
import { SMLThemeSwatch } from '../smartLinkDetailsView/rail/SMLThemeSwatch';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the sheet; each part uses its own slice of it */
import styles from './SMLCreationSheet.module.scss';
/* eslint-enable css-modules/no-unused-class */

const allThemes = Object.values(SerializedSmartLinkVersionTheme);

interface CreationThemeRowProps {
  theme: SerializedSmartLinkVersionTheme;
  disabled?: boolean;
  onChange: (theme: string) => void;
}

/**
 * All fourteen themes, four to a row.
 *
 * The old step 2 rendered a preview of the page in a theme the artist had not
 * chosen, in colours from no theme in the set. Real swatches teach the choice
 * instead, and the same shots the Creator's rail uses are the ones shown here.
 */
const CreationThemeRowComponent: React.FC<CreationThemeRowProps> = ({ theme, disabled, onChange }) => {
  const intl = useIntl();

  return (
    <div>
      <div className={styles.hint}>
        <span className={styles.hintLabel}>
          {intl.formatMessage({ id: 'app.sml.create.theme.label', defaultMessage: 'Theme' })}
        </span>
        <span className={styles.hintValue}>
          {intl.formatMessage({ id: 'app.sml.create.theme.hint', defaultMessage: 'changeable any time' })}
        </span>
      </div>
      <div className={styles.themes}>
        {allThemes.map((option) => (
          <SMLThemeSwatch
            key={option}
            option={option}
            checked={theme === option}
            disabled={disabled === true}
            onClick={onChange}
          />
        ))}
      </div>
    </div>
  );
};

export const CreationThemeRow = TypedMemo(CreationThemeRowComponent);
